import React from "react";
import { type CustomReportColumnConfig } from "shared/components/pillar-table/custom-reports/customReportColumnsMapper";
import { usePillarTableContext } from "shared/components/pillar-table/PillarTableContext";
import {
  usePillarTableRowContext,
  PillarTableRowContext,
} from "shared/components/pillar-table/row/PillarTableRowContext";

type PillarTableColumnChildProps = {
  rowValueOverride?: unknown;
  rowIndex?: number;
  cellValuePath?: string;
  columnConfig?: CustomReportColumnConfig;
  children?: React.ReactNode;
  valueOverride?: unknown;
};

const PillarTableColumnChild = ({
  rowValueOverride,
  rowIndex,
  cellValuePath,
  columnConfig,
  children,
  valueOverride,
}: PillarTableColumnChildProps) => {
  const { renderCustomReportColumn } = usePillarTableContext();
  const rowContext = usePillarTableRowContext();
  const childElement = columnConfig
    ? renderCustomReportColumn(columnConfig, undefined)
    : (children ?? null);

  if (!childElement) {
    return <></>;
  }

  const contextValue = {
    ...rowContext,
    rowValue: rowValueOverride ?? rowContext.rowValue,
    rowIndex: rowIndex ?? rowContext.rowIndex,
  };
  const injectedProps: Record<string, unknown> = {};
  const isElementWithProps = (
    element: React.ReactNode,
  ): element is React.ReactElement<Record<string, unknown>> =>
    React.isValidElement(element);

  if (
    valueOverride !== undefined &&
    isElementWithProps(childElement) &&
    childElement.props?.value === undefined
  ) {
    injectedProps.value = valueOverride;
  }
  if (
    cellValuePath !== undefined &&
    isElementWithProps(childElement) &&
    childElement.props?.cellValuePath === undefined
  ) {
    injectedProps.cellValuePath = cellValuePath;
  }

  return (
    <PillarTableRowContext.Provider value={contextValue}>
      {React.isValidElement(childElement)
        ? React.cloneElement(childElement, injectedProps)
        : childElement}
    </PillarTableRowContext.Provider>
  );
};

export default PillarTableColumnChild;
